import { isEmpty } from '~/modules';

export const fillStringIfEmpty = (text?: string, fillWith = '-') => {
  if (isEmpty(text)) return fillWith;
  return text;
};
